import {getData} from "../api/get-data";

export const setAskPrice = (itemId, price, link, email, phone, resolveHandler, rejectHanlder) => {
  getData({
    [`set_ack_price`]: {
      [`item_id`]: itemId,
      [`price`]: price,
      [`link`]: link,
      [`email`]: email,
      [`phone`]: phone,
    }
  })
  .then((response) => {
    if (response.result === `OK`) {
      resolveHandler();
    }

    if (response.result === `ERROR`) {
      rejectHanlder(response.error);
    }
  });
};
